import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const ease = [0.76, 0, 0.24, 1];

/** 첫 방문 시 한 번만 도는 인트로 오버레이 */
export default function Preloader() {
	const [done, setDone] = useState(() => {
		// 모션을 줄이도록 설정한 사용자에게는 인트로를 아예 보여주지 않는다
		if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return true;
		try {
			return sessionStorage.getItem("intro-played") === "1";
		} catch {
			return false;
		}
	});
	const [count, setCount] = useState(0);

	useEffect(() => {
		if (done) return undefined;

		const started = performance.now();
		const duration = 900;
		let frame;

		const tick = (now) => {
			const p = Math.min((now - started) / duration, 1);
			setCount(Math.round((1 - Math.pow(1 - p, 3)) * 100));
			if (p < 1) {
				frame = requestAnimationFrame(tick);
			} else {
				try {
					sessionStorage.setItem("intro-played", "1");
				} catch {
					/* 사용 불가 환경이면 그냥 넘어간다 */
				}
				setTimeout(() => setDone(true), 180);
			}
		};

		frame = requestAnimationFrame(tick);
		return () => cancelAnimationFrame(frame);
	}, [done]);

	return (
		<AnimatePresence>
			{!done && (
				<motion.div
					className="fixed inset-0 z-[120] flex flex-col justify-end bg-surface-page"
					exit={{ y: "-100%" }}
					transition={{ duration: 0.9, ease }}
				>
					<div className="container pb-12">
						<div className="flex items-end justify-between">
							<span className="font-mono text-[11px] uppercase tracking-[0.24em] text-content-faint">
								Oh Taehun — Backend Engineer
							</span>
							<span className="font-display text-[clamp(3.5rem,14vw,11rem)] font-bold leading-none tracking-tighter text-content-primary">
								{count}
								<span className="text-accent">%</span>
							</span>
						</div>
						<div className="mt-8 h-px w-full bg-edge">
							<motion.div className="h-px bg-accent" style={{ width: `${count}%` }} />
						</div>
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	);
}
